import { render, staticRenderFns } from "./addendum-history.vue?vue&type=template&id=744db96d&scoped=true&"
import script from "./addendum-history.vue?vue&type=script&lang=js&"
export * from "./addendum-history.vue?vue&type=script&lang=js&"
import style0 from "./addendum-history.vue?vue&type=style&index=0&id=744db96d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744db96d",
  null
  
)

export default component.exports